/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPayment} from '../api'

 export const useQueryGetPayment = createReactQueryHook('getPayment', getPayment)
